import React from 'react';

// six-dot drag handle (Feather has none), same 24-grid as react-icons/fi; also the "Tick boxes" answer type (423:15337)
const GripIcon: React.FC = () =>
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        {[6, 12, 18].map(y => <React.Fragment key={y}><circle cx="9" cy={y} r="1.6" /><circle cx="15" cy={y} r="1.6" /></React.Fragment>)}
    </svg>;

export default GripIcon;
